import { combineReducers } from 'redux';
import clicks from './clicks';
import palette from './palette';

export default combineReducers({ clicks, palette });
